import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
// Choose your version:
// import AppUltraMinimal from './AppUltraMinimal';        // ✅ Always works (demo)
// import AppWithMSALFixed from './AppWithMSALFixed';       // 🔐 Real auth (needs Azure setup)
import AppWithRedux from './AppWithRedux';               // 🎯 Redux + Teams auth (matches Slack pattern)
// import AppWithStripe from './AppWithStripe';           // 💳 Full production
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppWithRedux />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
